import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../api/services/auth';
import { useInput } from '../hooks/useInput';
import { HalfCircleSpinner } from 'react-epic-spinners';
import ForgotPasswordForm from "./forgotPassowordForm";
import { toast } from 'react-toastify';
import { Button } from './ui/button';
import { FieldLabel } from './ui/field-label';
import { Input } from './ui/input';
import { PasswordInput } from './ui/password-input';

const LoginForm = ({ showForgotPasswordForm, setShowForgotPasswordForm }) => {
    const [username, bindUsername, resetUsername] = useInput("");
    const [password, bindPassword, resetPassword] = useInput("");
    const [errors, setErrors] = useState({});
    const { login, LoginError, showLoader, setShowLoader } = useAuth();

    // Check_Validation_Function
    const validateLogin = () => {
        let errors = {};
        let isValid = true;
        if (!username) {
            isValid = false;
            errors['username'] = 'Please enter your Username.';
            toast.error('Please enter your Username.');
        }
        if (!password) {
            isValid = false;
            errors['password'] = 'Please enter your Password.';
            toast.error('Please enter your Password.');
        }
        setErrors(errors);
        return isValid;
    };

    const loginHandler = async (event) => {
        event.preventDefault();
        if (validateLogin()) {
            try {
                await login(username, password); // Assuming `login` is an async function.
                const urlState = { username, password };
                window.history.pushState(urlState, "", window.location.href);
            } catch (error) {
                setShowLoader(false)
                if (error && error.status === 401) {
                    toast.error(error?.data?.message ?? "Invalid username or password.");
                } else {
                    toast.error(error?.data?.message ?? "Something went wrong. Please try again later.");
                }
            }
        }
    };


    return (
        <>
            {!showForgotPasswordForm && (
                <form className="space-y-4" onSubmit={(event) => loginHandler(event)}>
                    <div>
                        <FieldLabel required htmlFor="login-username">Username</FieldLabel>
                        <Input
                            id="login-username"
                            className={`mt-1 ${errors.username ? 'border-danger' : ''}`}
                            type="text"
                            placeholder="Username"
                            autoCapitalize="none"
                            autoCorrect="off"
                            spellCheck={false}
                            {...bindUsername}
                        />
                    </div>
                    <div>
                        <FieldLabel required htmlFor="login-password">Password</FieldLabel>
                        <PasswordInput
                            id="login-password"
                            wrapperClassName="mt-1"
                            className={errors.password ? 'border-danger' : ''}
                            placeholder="Password"
                            autoComplete="current-password"
                            {...bindPassword}
                        />
                    </div>
                    <Button type="submit" className="w-full" disabled={showLoader}>
                        Login
                        {showLoader && (
                            <HalfCircleSpinner size={18} style={{ display: 'inline-block' }} />
                        )}
                    </Button>
                    <Link to="/request-demo" className="block">
                        <Button type="button" variant="secondary" className="w-full">
                            Request a demo
                        </Button>
                    </Link>
                    <p className="text-center text-sm text-ink-600">
                        <button
                            type='button'
                            className='font-semibold text-green-600 hover:text-green-700'
                            onClick={() => {
                                setErrors('')
                                resetUsername()
                                resetPassword()
                                setShowForgotPasswordForm(true)
                            }}
                        >Forgot Password?</button>
                    </p>
                    {LoginError && (
                        <div className="rounded-md border border-danger/30 bg-danger-lt px-3 py-2 text-sm text-danger">{LoginError}</div>
                    )}
                </form>
            )}
            {showForgotPasswordForm && (
                <ForgotPasswordForm
                    setShowForgotPasswordForm={setShowForgotPasswordForm}
                />
            )}
        </>
    );
}

export default LoginForm;
